import { Loader2 } from "lucide-react";

import { Card, CardBody } from "@/components/ui/Card";

/**
 * Shown on hard refresh or a new tab until this tab’s holder stream is open.
 * Other tabs are unaffected. Not the slow-request banner.
 * Inline colors keep the copy visible even if Tailwind has not painted yet.
 */
export function HubSessionConnectingScreen({ failed = false }: { failed?: boolean }): JSX.Element {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-slate-50 px-4"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8fafc",
        color: "#0f172a",
        padding: 16,
      }}
    >
      <Card className="w-full max-w-md" style={{ width: "100%", maxWidth: 28 * 16 }}>
        <CardBody className="flex flex-col items-center gap-3 py-10 text-center">
          <Loader2 className="h-6 w-6 animate-spin text-slate-500" aria-hidden />
          <p className="text-base font-semibold text-slate-900" style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>
            Connecting to the hub…
          </p>
          <p className="text-sm text-slate-600" style={{ fontSize: 14, color: "#475569", margin: 0 }}>
            Opening this tab's live connection before loading the page.
          </p>
          {failed ? (
            <>
              <p className="text-sm text-slate-700" style={{ fontSize: 14, color: "#334155", margin: 0 }} role="status">
                The live connection did not open yet. This tab is still retrying after a brief hub handoff.
              </p>
              <button
                type="button"
                className="mt-1 text-sm font-medium text-slate-900 underline decoration-slate-400 underline-offset-2"
                style={{ fontSize: 14, fontWeight: 600, color: "#0f172a" }}
                onClick={() => {
                  window.location.reload();
                }}
              >
                Reload
              </button>
            </>
          ) : null}
        </CardBody>
      </Card>
    </div>
  );
}
